import React from 'react';
import MetricCard from '@/components/ui/MetricCard';
import { Users, UtensilsCrossed, TrendingDown, AlertTriangle, Activity } from 'lucide-react';

// 5 cards → grid-cols-2 md + hero spans 2 cols on xl → xl: 3+2 pattern
// Row 1: hero (spans 2) + 2 regular = 4 cols
// Row 2: 3 regular = covered by grid-cols-2 sm / grid-cols-3 lg
export default function ProKPIGrid() {
  return (
    <div data-component-id="src/app/professional-admin-panel/components/ProKPIGrid.tsx:10:4" data-component-path="src/app/professional-admin-panel/components/ProKPIGrid.tsx" data-component-line="10" data-component-end-line="56" data-component-file="ProKPIGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-3%20xl%3Agrid-cols-5%202xl%3Agrid-cols-5%20gap-4%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-5 gap-4">
      <MetricCard data-component-id="src/app/professional-admin-panel/components/ProKPIGrid.tsx:11:6" data-component-path="src/app/professional-admin-panel/components/ProKPIGrid.tsx" data-component-line="11" data-component-end-line="19" data-component-file="ProKPIGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%2212%22%2C%22className%22%3A%22xl%3Acol-span-1%22%7D"
        label="Pets Under Care"
        value="12"
        subValue="3 new this month"
        icon={Users}
        trend={{ value: '+3 this month', positive: true }}
        variant="accent"
        className="xl:col-span-1"
      />
      <MetricCard data-component-id="src/app/professional-admin-panel/components/ProKPIGrid.tsx:20:6" data-component-path="src/app/professional-admin-panel/components/ProKPIGrid.tsx" data-component-line="20" data-component-end-line="28" data-component-file="ProKPIGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%2234%22%2C%22className%22%3A%22xl%3Acol-span-1%22%7D"
        label="Meals Served Today"
        value="34"
        subValue="Across all pets"
        icon={UtensilsCrossed}
        trend={{ value: '+2 vs yesterday', positive: true }}
        variant="positive"
        className="xl:col-span-1"
      />
      <MetricCard data-component-id="src/app/professional-admin-panel/components/ProKPIGrid.tsx:29:6" data-component-path="src/app/professional-admin-panel/components/ProKPIGrid.tsx" data-component-line="29" data-component-end-line="37" data-component-file="ProKPIGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%223%22%2C%22className%22%3A%22xl%3Acol-span-1%22%7D"
        label="Nutrition Flags"
        value="3"
        subValue="Require attention"
        icon={TrendingDown}
        trend={{ value: '2 underweight, 1 over', positive: false }}
        variant="danger"
        className="xl:col-span-1"
      />
      <MetricCard data-component-id="src/app/professional-admin-panel/components/ProKPIGrid.tsx:38:6" data-component-path="src/app/professional-admin-panel/components/ProKPIGrid.tsx" data-component-line="38" data-component-end-line="46" data-component-file="ProKPIGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%225%22%2C%22className%22%3A%22xl%3Acol-span-1%22%7D"
        label="Active Alerts"
        value="5"
        subValue="2 critical, 3 warnings"
        icon={AlertTriangle}
        trend={{ value: '+2 since yesterday', positive: false }}
        variant="warning"
        className="xl:col-span-1"
      />
      <MetricCard data-component-id="src/app/professional-admin-panel/components/ProKPIGrid.tsx:47:6" data-component-path="src/app/professional-admin-panel/components/ProKPIGrid.tsx" data-component-line="47" data-component-end-line="55" data-component-file="ProKPIGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%2281%25%22%2C%22className%22%3A%22xl%3Acol-span-1%22%7D"
        label="Avg Presence Rate"
        value="81%"
        subValue="Pets eating on schedule"
        icon={Activity}
        trend={{ value: '-3% vs last week', positive: false }}
        variant="default"
        className="xl:col-span-1"
      />
    </div>
  );
}